// Theme: skyline-code
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'skyline-code',
  name: 'SKYLINE CODE',
  tagline: 'SKYLINE CODE',
  description: 'Codigo do horizonte com azul urbano profundo de metropole.',
  category: 'urban-expression',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#080F18', '#0F1D30', '#2563EB', '#DBEAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-skyline-code'
  },
  colorVars: {
    '--accent': '#2563EB',
    '--accent-foreground': '#080F18',
    '--background': '#080F18',
    '--border': '#1A3A6A',
    '--card': '#0F1D30',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DBEAFE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#080F18',
    '--foreground': '#DBEAFE',
    '--hold-fill': '#2563EB',
    '--input': '#1A3A6A',
    '--modal-bg': '#080F18',
    '--modal-border': '#1A3A6A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#1A3A6A',
    '--muted-foreground': '#DBEAFE',
    '--nav-active': '#2563EB',
    '--nav-bg': '#0F1D30',
    '--popover': '#0F1D30',
    '--popover-foreground': '#DBEAFE',
    '--primary': '#2563EB',
    '--primary-foreground': '#080F18',
    '--ring': '#2563EB',
    '--secondary': '#1A3A6A',
    '--secondary-foreground': '#DBEAFE',
    '--streak': '#2563EB',
    '--success': '#22c55e',
    '--success-foreground': '#080F18',
    '--xp': '#2563EB',
    '--xp-bg': '#0F1D30'
  },
  resolvedVars: {
    '--accent': '#2563EB',
    '--accent-foreground': '#080F18',
    '--accent-foreground-hsl': '214 50% 6%',
    '--accent-foreground-oklch': 'from #080F18 l c h',
    '--accent-hsl': '221 83% 53%',
    '--accent-oklch': 'from #2563EB l c h',
    '--background': '#080F18',
    '--background-hsl': '214 50% 6%',
    '--background-oklch': 'from #080F18 l c h',
    '--border': '#1A3A6A',
    '--border-hsl': '216 61% 26%',
    '--border-oklch': 'from #1A3A6A l c h',
    '--border-w': '1px',
    '--card': '#0F1D30',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#DBEAFE',
    '--card-foreground-hsl': '214 95% 93%',
    '--card-foreground-oklch': 'from #DBEAFE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '215 52% 12%',
    '--card-oklch': 'from #0F1D30 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#080F18',
    '--destructive-foreground-hsl': '214 50% 6%',
    '--destructive-foreground-oklch': 'from #080F18 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#DBEAFE',
    '--foreground-hsl': '214 95% 93%',
    '--foreground-oklch': 'from #DBEAFE l c h',
    '--hold-fill': '#2563EB',
    '--hold-fill-hsl': '221 83% 53%',
    '--hold-fill-oklch': 'from #2563EB l c h',
    '--input': '#1A3A6A',
    '--input-hsl': '216 61% 26%',
    '--input-oklch': 'from #1A3A6A l c h',
    '--modal-bg': '#080F18',
    '--modal-bg-hsl': '214 50% 6%',
    '--modal-bg-oklch': 'from #080F18 l c h',
    '--modal-border': '#1A3A6A',
    '--modal-border-hsl': '216 61% 26%',
    '--modal-border-oklch': 'from #1A3A6A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#1A3A6A',
    '--muted-foreground': '#DBEAFE',
    '--muted-foreground-hsl': '214 95% 93%',
    '--muted-foreground-oklch': 'from #DBEAFE l c h',
    '--muted-hsl': '216 61% 26%',
    '--muted-oklch': 'from #1A3A6A l c h',
    '--nav-active': '#2563EB',
    '--nav-active-hsl': '221 83% 53%',
    '--nav-active-oklch': 'from #2563EB l c h',
    '--nav-bg': '#0F1D30',
    '--nav-bg-hsl': '215 52% 12%',
    '--nav-bg-oklch': 'from #0F1D30 l c h',
    '--popover': '#0F1D30',
    '--popover-foreground': '#DBEAFE',
    '--popover-foreground-hsl': '214 95% 93%',
    '--popover-foreground-oklch': 'from #DBEAFE l c h',
    '--popover-hsl': '215 52% 12%',
    '--popover-oklch': 'from #0F1D30 l c h',
    '--primary': '#2563EB',
    '--primary-foreground': '#080F18',
    '--primary-foreground-hsl': '214 50% 6%',
    '--primary-foreground-oklch': 'from #080F18 l c h',
    '--primary-hsl': '221 83% 53%',
    '--primary-oklch': 'from #2563EB l c h',
    '--radius': '12px',
    '--ring': '#2563EB',
    '--ring-hsl': '221 83% 53%',
    '--ring-oklch': 'from #2563EB l c h',
    '--secondary': '#1A3A6A',
    '--secondary-foreground': '#DBEAFE',
    '--secondary-foreground-hsl': '214 95% 93%',
    '--secondary-foreground-oklch': 'from #DBEAFE l c h',
    '--secondary-hsl': '216 61% 26%',
    '--secondary-oklch': 'from #1A3A6A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#2563EB',
    '--streak-hsl': '221 83% 53%',
    '--streak-oklch': 'from #2563EB l c h',
    '--success': '#22c55e',
    '--success-foreground': '#080F18',
    '--success-foreground-hsl': '214 50% 6%',
    '--success-foreground-oklch': 'from #080F18 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(221 83% 53% / 0.15)',
    '--xp': '#2563EB',
    '--xp-bg': '#0F1D30',
    '--xp-bg-hsl': '215 52% 12%',
    '--xp-bg-oklch': 'from #0F1D30 l c h',
    '--xp-hsl': '221 83% 53%',
    '--xp-oklch': 'from #2563EB l c h'
  }
}
